module.exports = new __parcel__URL__("Charlie_Display-Bold.0d294e31.woff2").toString();